import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DashboardService } from 'src/services/dashboard.service';
import { NotificationService } from 'src/services/notification.service';

@Component({
  selector: 'app-project-deadlines',
  templateUrl: './project-deadlines.component.html',
  styleUrls: ['./project-deadlines.component.css']
})
export class ProjectDeadlinesComponent implements OnInit {

  public loginUser: any = {};
  public allDeadlines: any[] = [];
  public allActiveProjects: any[] = [];
  public isLoading: boolean = false;
  public isSaving: boolean = false;

  // Create form
  public newProjectId: number = 0;
  public newTitle: string = '';
  public newStartDate: string = '';
  public newEndDate: string = '';
  public newStatus: string = 'Incomplete';
  public newModule: string = '';

  // Inline edit
  public editingId: number = 0;
  public editData: any = {};

  constructor(
    private appService: AppService,
    private dashboardService: DashboardService,
    private noti: NotificationService
  ) {}

  ngOnInit() {
    this.appService.headerTitle.emit({ data: 'Project Deadlines' });
    this.loginUser = JSON.parse(localStorage.getItem('user'));
    this.loadActiveProjects();
    this.loadDeadlines();
  }

  loadActiveProjects() {
    this.dashboardService.getAllActiveProjectsForDeadline().subscribe(res => {
      if (res.status == 'ok') {
        this.allActiveProjects = res.data;
      }
    }, error => {});
  }

  loadDeadlines() {
    this.isLoading = true;
    this.dashboardService.getAllProjectDeadlines().subscribe(res => {
      this.isLoading = false;
      if (res.status == 'ok') {
        this.allDeadlines = res.data;
      }
    }, error => { this.isLoading = false; });
  }

  createDeadline() {
    if (!this.newProjectId || !this.newTitle.trim() || !this.newEndDate) {
      this.noti.notification('Error', 'Project, Title and End Date are required', 'danger');
      return;
    }
    this.isSaving = true;
    const body = {
      ProjectId: this.newProjectId,
      Title: this.newTitle.trim(),
      StartDate: this.newStartDate ? new Date(this.newStartDate) : null,
      EndDate: new Date(this.newEndDate),
      DeadlineDate: new Date(this.newEndDate),
      Status: this.newStatus || 'Incomplete',
      Module: this.newModule.trim()
    };
    this.dashboardService.createProjectDeadline(body).subscribe(res => {
      this.isSaving = false;
      if (res.status == 'ok') {
        this.noti.notification('Success', 'Deadline added successfully', 'success');
        this.newProjectId = 0;
        this.newTitle = '';
        this.newStartDate = '';
        this.newEndDate = '';
        this.newStatus = 'Incomplete';
        this.newModule = '';
        this.loadDeadlines();
      } else {
        this.noti.notification('Error', 'Failed to add deadline', 'danger');
      }
    }, error => { this.isSaving = false; });
  }

  startEdit(dl: any) {
    this.editingId = dl.id;
    this.editData = {
      projectId: dl.projectId,
      title: dl.title,
      startDate: dl.startDate ? dl.startDate.substring(0, 10) : '',
      endDate: dl.endDate ? dl.endDate.substring(0, 10) : '',
      status: dl.status || 'Incomplete',
      module: dl.module || ''
    };
  }

  cancelEdit() {
    this.editingId = 0;
    this.editData = {};
  }

  saveEdit(id: number) {
    const body = {
      ProjectId: this.editData.projectId,
      Title: this.editData.title,
      StartDate: this.editData.startDate ? new Date(this.editData.startDate) : null,
      EndDate: this.editData.endDate ? new Date(this.editData.endDate) : null,
      Status: this.editData.status,
      Module: this.editData.module
    };
    this.dashboardService.updateProjectDeadline(id, body).subscribe(res => {
      if (res.status == 'ok') {
        this.noti.notification('Success', 'Deadline updated', 'success');
        this.cancelEdit();
        this.loadDeadlines();
      } else {
        this.noti.notification('Error', 'Update failed', 'danger');
      }
    }, error => {});
  }

  deleteDeadline(id: number) {
    if (!confirm('Are you sure you want to delete this deadline?')) return;
    this.dashboardService.deleteProjectDeadline(id).subscribe(res => {
      if (res.status == 'ok') {
        this.noti.notification('Success', 'Deadline deleted', 'success');
        this.loadDeadlines();
      } else {
        this.noti.notification('Error', 'Delete failed', 'danger');
      }
    }, error => {});
  }
}
